import { CONVERSATION_ID_KEY } from '@chatbot/constants/chat';

/**
 * Save conversation ID to localStorage
 * @param id - The conversation ID to save
 */
export const saveConversationId = (id: string): void => {
    try {
        localStorage.setItem(CONVERSATION_ID_KEY, id);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error saving conversation ID to localStorage:', error);
    }
};

/**
 * Get conversation ID from localStorage
 * @returns The conversation ID or null if not found
 */
export const getConversationId = (): string | null => {
    try {
        return localStorage.getItem(CONVERSATION_ID_KEY);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error getting conversation ID from localStorage:', error);
        return null;
    }
};

/**
 * Remove conversation ID from localStorage
 */
export const removeConversationId = (): void => {
    try {
        localStorage.removeItem(CONVERSATION_ID_KEY);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error removing conversation ID from localStorage:', error);
    }
};
